import bafPdf from 'assets/PDF/wemi_baf_famiglie.pdf';

export const pdf = {
  download: bafPdf,
  downloadName: 'wemi_baf_famiglie',
  value: "Scaricare l'informativa",
};
